module.exports = __webpack_public_path__ + "static/media/petite.35f1152d.png";